import styled, { ITheme } from '../../../theme'

const TimerBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: ${(props: ITheme) => props.theme.colors.palette.paleGrey};
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
  padding: 12px 10px;
  margin-right: 5px;
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    font-size: 12px;
  }
`

export default TimerBadge
